<template>
    <div class="user-info flex">
        <base-user-avatar
            class="user-image-container"
            @click="handleUploadModal"
        />
        <base-user-details />
        <button
            v-if="!user.pro"
            class="btn"
            @click="openUpgradeModal"
        >
            Upgrade to Pro Now
        </button>
        <transition
            name="fade"
        >
             <image-modal
                v-if="imageModal"
                @close-modal="handleUploadModal"
            />
        </transition>
    </div>
</template>

<script>
import ImageModal from './ImageModal.vue';
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
    components: {
        ImageModal,
    },

    data: () => ({
        imageModal: false,
    }),

    computed: {
        ...mapState(['user']),
        ...mapGetters(['avatarUrl']),
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Opens image upload modal
         *
         */
        handleUploadModal() {
            this.imageModal = ! this.imageModal;
        },

        /**
         * Opens upgrade modal
         *
         */
        openUpgradeModal() {
            this.changeUIState({ isUpgradeModalVisible: true });
        },
    },
};
</script>
